import {
	Dialog,
	Paper,
	DialogTitle,
	DialogContent,
	Box,
	Typography,
	TextField,
	DialogActions,
	RadioGroup,
	FormControlLabel,
	Radio,
	Checkbox,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	SelectChangeEvent,
} from '@mui/material'
import { useMemo, useState } from 'react'
import CustomButton from '../../CustomButton/CustomButton'
import { useModal } from '../../../../../store/ModalProvider'
import dayjs from 'dayjs'
import BonusCodes from '../../../../timesheet/details/v1/BonusCodes/BonusCodes'
import TimesheetServices from '../../../../timesheet/details/v1/TimesheetServices'
import WorkRegimeAndAgent from '../../../../timesheet/details/v1/WorkRegimeAndAgent'
import { useGetWorkTypesQuery } from '../../../../../store/api/timesheet/timesheetWorkTypesApi'
import { useIsTimesheetApproved } from '../../../../../utils/hooks/approvedTimesheet'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../../store/store'
import { acceptApproval } from '../../../../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice'
import { handleDetails } from '../../../../../store/slices/timesheet/timesheetPageSlice'
import { hasChanges } from '../../../../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalHasChangesSlice'
import { TimesheetStoreState } from '../../../../../store/timesheetStore'

const data = {
	requisition: 'manual',
	replicateSchedule: true,
	timeSheetDate: '2023-10-01',
	comments:
		'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
	isSubmitted: false,
	isBlocked: false,
	timeSheetId: 12345,
	workTypeId: 0,
	dispDrivingBreak: '0',
	uniqueAgent: '00:00',
	status: 'Not Submitted',
	initialStatus: null,
	driver: {
		driverId: 3452,
		internalNumber: 7890,
		driverName: 'John Doe',
		companyName: 'Transol',
	},
	services: [
		{
			service: {
				serviceId: 5678,
				clientName: 'Travel One Lisboa - Agência de viagens e turismo, lda',
				origin: 'Lagos - Hotel Vila Galé',
				destination: 'Faro - Aeroporto',
				startDateTime: '2023-10-01T08:45:00Z',
				endDateTime: '2023-10-01T10:00:00Z',
				pax: 40,
				isClean: true,
				isReserve: true,
				contract: 'Antrop',
				reference: '74',
				endTimeErrorComment: null,
				startTimeErrorComment: null,
				paxErrorComment: null,
				kmsEmpty: 20,
				kmsFull: 130,
				vehicle: {
					licencePlate: '12-34-AB',
					fleetNumber: '1234',
					kmsInServices: 15000,
					kmsOutsideServices: 5000,
					kmsTotal: 20000,
				},
				comments:
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
				kmsVehicles: [
					{
						kmsId: 69,
						kmsIni: 20000,
						kmsEnd: 20010,
						inEmpty: true,
					},
					{
						kmsId: 70,
						kmsIni: 20010,
						kmsEnd: 20050,
						inEmpty: false,
					},
					{
						kmsId: 71,
						kmsIni: 20050,
						kmsEnd: 20060,
						inEmpty: true,
					},
				],
			},
			mainSecundaryDriver: null,
			mainSecundaryDriverTimeSheetId: null,
			mainSecundaryDriverTimeSheetStatus: null,
		},
		{
			service: {
				serviceId: 5679,
				clientName: 'Travel One Lisboa - Agência de viagens e turismo, lda',
				origin: 'Faro - Aeroporto',
				destination: 'Lagos - Hotel Vila Galé',
				startDateTime: '2023-10-01T11:45:00Z',
				endDateTime: '2023-10-01T13:00:00Z',
				pax: 45,
				isClean: true,
				isReserve: true,
				contract: 'Antrop',
				reference: '74',
				endTimeErrorComment: null,
				startTimeErrorComment: null,
				paxErrorComment: null,
				kmsEmpty: 20,
				kmsFull: 130,
				vehicle: {
					licencePlate: '12-34-AB',
					fleetNumber: '1234',
					kmsInServices: 15000,
					kmsOutsideServices: 5000,
					kmsTotal: 20000,
				},
				comments:
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
				kmsVehicles: [
					{
						kmsId: 72,
						kmsIni: 20060,
						kmsEnd: 20070,
						inEmpty: true,
					},
					{
						kmsId: 73,
						kmsIni: 20070,
						kmsEnd: 20100,
						inEmpty: false,
					},
					{
						kmsId: 74,
						kmsIni: 20100,
						kmsEnd: 20120,
						inEmpty: true,
					},
				],
			},
			mainSecundaryDriver: null,
			mainSecundaryDriverTimeSheetId: null,
			mainSecundaryDriverTimeSheetStatus: null,
		},
	],
	vehicles: [
		{
			licencePlate: '12-34-AB',
			fleetNumber: '1234',
			kmsInServices: 15000,
			kmsOutsideServices: 5000,
			kmsTotal: 20000,
		},
	],
	workTimes: [
		{
			timeSheetApprovalWorkTimesId: 0,
			isClean: true,
			startTime: '08:45',
			endTime: '10:00',
		},
		{
			timeSheetApprovalWorkTimesId: 0,
			isClean: true,
			startTime: '11:45',
			endTime: '13:00',
		},
	],
	extraTimePayment: true,
	bonusCodes: [
		{
			code: '3',
			description: 'Almoço',
			codeId: 4,
		},
		{
			code: '4',
			description: 'Subsidio Refeição',
			codeId: 5,
		},
	],
}

const CustomModalVirtualTimesheet: React.FC = () => {
	const dispatch = useDispatch<AppDispatch>()
	const timesheetPage = useSelector((state: TimesheetStoreState) => state.timesheetPage)
	const loadedData = useMemo(() => data, [data])

	const { closeModal, modalHandlers } = useModal()

	const [saveChages] = modalHandlers
	const [workType, setWorkType] = useState(String(timesheetPage.workTypeId))

	const { data: workTypes } = useGetWorkTypesQuery()
	const isTimeSheetApproved = useIsTimesheetApproved()
	const timesheetApprovalDetailsAccept = useSelector(
		(state: TimesheetStoreState) => state.timesheetApprovalDetailsAccept,
	)

	function handleWork(event: SelectChangeEvent<string | string[]>) {
		setWorkType(event.target.value as string)
		if (isTimeSheetApproved) {
			dispatch(
				acceptApproval({
					...timesheetApprovalDetailsAccept,
					workTypeId: Number(event.target.value),
				}),
			)
		} else {
			dispatch(
				handleDetails({
					workTypeId: Number(event.target.value),
				}),
			)
		}
		dispatch(hasChanges({ hasChangesFromReviewer: true }))
	}

	const elapsedworktimes = loadedData.workTimes.map(wt => {
		const start = dayjs()
			.set('hour', parseInt(wt.startTime.split(':')[0]))
			.set('minute', parseInt(wt.startTime.split(':')[1]))
		const end = dayjs()
			.set('hour', parseInt(wt.endTime.split(':')[0]))
			.set('minute', parseInt(wt.endTime.split(':')[1]))
		const workTimeDiff = end.diff(start, 'minute')
		const hours = Math.floor(workTimeDiff / 60)
		const minutes = workTimeDiff % 60
		return dayjs().set('hour', hours).set('minute', minutes)
	})

	const totalHours = loadedData.workTimes.reduce((total, wt) => {
		const start = dayjs()
			.set('hour', parseInt(wt.startTime.split(':')[0]))
			.set('minute', parseInt(wt.startTime.split(':')[1]))
		const end = dayjs()
			.set('hour', parseInt(wt.endTime.split(':')[0]))
			.set('minute', parseInt(wt.endTime.split(':')[1]))
		const workTimeDiff = end.diff(start, 'minute')
		return total + workTimeDiff
	}, 0)

	// Calculates the total amout of time, in hours (HH:mm), taken place in the period between 3am and 7am
	const nightMorningHours = loadedData.workTimes.reduce((total, wt) => {
		const start = dayjs()
			.set('hour', parseInt(wt.startTime.split(':')[0]))
			.set('minute', parseInt(wt.startTime.split(':')[1]))
		const end = dayjs()
			.set('hour', parseInt(wt.endTime.split(':')[0]))
			.set('minute', parseInt(wt.endTime.split(':')[1]))

		let periodStart = start
		let periodEnd = end

		// Adjust period to fit within 3am to 7am
		if (periodStart.isBefore(periodStart.set('hour', 3).set('minute', 0))) {
			periodStart = periodStart.set('hour', 3).set('minute', 0)
		}
		if (periodEnd.isAfter(periodEnd.set('hour', 7).set('minute', 0))) {
			periodEnd = periodEnd.set('hour', 7).set('minute', 0)
		}

		if (periodEnd.isAfter(periodStart)) {
			const overlap = periodEnd.diff(periodStart, 'minute')
			return total + overlap
		}
		return total
	}, 0)

	// Calculates the total amout of time, in hours (HH:mm), taken place in the period between 7am and 8pm
	const diurnalHours = loadedData.workTimes.reduce((total, wt) => {
		const start = dayjs()
			.set('hour', parseInt(wt.startTime.split(':')[0]))
			.set('minute', parseInt(wt.startTime.split(':')[1]))
		const end = dayjs()
			.set('hour', parseInt(wt.endTime.split(':')[0]))
			.set('minute', parseInt(wt.endTime.split(':')[1]))
		let periodStart = start
		let periodEnd = end
		// Adjust period to fit within 7am to 8pm
		if (periodStart.isBefore(periodStart.set('hour', 7).set('minute', 0))) {
			periodStart = periodStart.set('hour', 7).set('minute', 0)
		}
		if (periodEnd.isAfter(periodEnd.set('hour', 20).set('minute', 0))) {
			periodEnd = periodEnd.set('hour', 20).set('minute', 0)
		}
		if (periodEnd.isAfter(periodStart)) {
			const overlap = periodEnd.diff(periodStart, 'minute')
			return total + overlap
		}
		return total
	}, 0)

	// Calculates the total amout of time, in hours (HH:mm), taken place in the period between 8pm and 3am
	const nightAfternoonHours = loadedData.workTimes.reduce((total, wt) => {
		const start = dayjs()
			.set('hour', parseInt(wt.startTime.split(':')[0]))
			.set('minute', parseInt(wt.startTime.split(':')[1]))
		const end = dayjs()
			.set('hour', parseInt(wt.endTime.split(':')[0]))
			.set('minute', parseInt(wt.endTime.split(':')[1]))
		let periodStart = start
		let periodEnd = end
		// Adjust period to fit within 8pm to 3am
		if (periodStart.isBefore(periodStart.set('hour', 20).set('minute', 0))) {
			periodStart = periodStart.set('hour', 20).set('minute', 0)
		}
		if (periodEnd.isAfter(periodEnd.set('hour', 3).set('minute', 0))) {
			periodEnd = periodEnd.set('hour', 3).set('minute', 0)
		}
		if (periodEnd.isAfter(periodStart)) {
			const overlap = periodEnd.diff(periodStart, 'minute')
			return total + overlap
		}
		return total
	}, 0)

	// Calculates the extra hours beyond 8 hours of work
	const extraHours = totalHours > 480 ? totalHours - 480 : 0

	return (
		// TODO: Add respective providers, on the parent, and handlers to make the modal functional
		<Dialog
			open={true}
			maxWidth='xl'
		>
			<Paper
				sx={{
					width: '60vw',
					padding: '1.5rem 1rem',
					display: 'flex',
					flexDirection: 'column',
					gap: '1.5rem',
				}}
			>
				<DialogTitle
					id='virtual-timesheet-modal-subtitle'
					variant='h6'
					gutterBottom={false}
					sx={{
						margin: 0,
						padding: 0,
						fontSize: '1rem',
						fontFamily: 'Poppins, sans-serif',
						color: 'var(--primary-dark)',
						fontWeight: 600,
						lineHeight: '1.57',
						letterSpacing: '0.15px',
					}}
				>
					Folha de Ponto Virtual - {loadedData.driver.driverName} -{' '}
					{dayjs(loadedData.timeSheetDate).format('DD/MM/YYYY')}
				</DialogTitle>
				<Typography
					id='virtual-timesheet-modal-title'
					variant='h5'
					component='h5'
					sx={{
						margin: 0,
						padding: 0,
						fontWeight: 600,
						fontSize: '1.5rem',
						fontFamily: 'Poppins, sans-serif',
						color: 'var(--primary-dark)',
						lineHeight: '133.4%',
					}}
				>
					{'Folha de Ponto Virtual'}
				</Typography>
				<DialogContent sx={{ margin: 0, padding: 0 }}>
					{/* Requisition - TODO: move to separate component */}
					<Typography
						variant='h6'
						sx={{
							fontFamily: 'Poppins, sans-serif',
							fontWeight: 600,
							fontSize: '1.25rem',
							lineHeight: '160%',
						}}
					>
						Requisição
					</Typography>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: '1rem',
							alignSelf: 'stretch',
						}}
					>
						<RadioGroup
							row
							aria-labelledby='requisition-radio-group-label'
							name='requisition-radio-group'
							value={loadedData.requisition}
							// onChange={} // TODO: implement onChange handler
							sx={{
								marginLeft: '8px',
								gap: '1.5rem',
								'& .MuiTypography-body1': {
									fontFamily: 'Poppins, sans-serif',
									fontSize: '13px',
									fontWeight: 500,
									lineHeight: '130%',
									letterSpacing: '-1px',
									color: '#092056',
								},
								'& .MuiFormControlLabel-root': {
									display: 'flex',
									alignItems: 'center',
									gap: '0.125rem',
									marginRight: 0,
								},
								'& .MuiRadio-root': {
									padding: '2px',
								},
								'& .MuiSvgIcon-root': {
									fontSize: 18,
								},
							}}
						>
							<FormControlLabel
								value='chapa'
								label='Chapa'
								control={
									<Radio
										size='small'
										sx={{ fontSize: 18 }}
									/>
								}
								sx={{}}
							/>
							<FormControlLabel
								value='auto'
								label='Automático'
								control={
									<Radio
										size='small'
										sx={{ fontSize: 18 }}
									/>
								}
								sx={{}}
							/>
							<FormControlLabel
								value='manual'
								label='Manual'
								control={
									<Radio
										size='small'
										sx={{ fontSize: 18 }}
									/>
								}
								sx={{}}
							/>
						</RadioGroup>

						<Box
							sx={{
								width: '1px',
								height: '24px',
								backgroundColor: 'rgba(134, 149, 175, 0.15)',
							}}
						/>

						<FormControlLabel
							label='Replicar Horário'
							control={
								<Checkbox
									size='small'
									checked={loadedData.replicateSchedule}
									onChange={() => {}} // TODO: implement onChange handler
								/>
							}
							labelPlacement='end'
							sx={{
								'& .MuiTypography-body1': {
									fontFamily: 'Poppins, sans-serif',
									fontSize: '13px',
									fontWeight: 500,
									lineHeight: '130%',
									letterSpacing: '-1px',
									color: '#092056',
								},
							}}
						/>
					</Box>

					{/* Work Periods and Work Regime & Availability */}
					<Box
						sx={{
							marginTop: '1.5rem',
							display: 'grid',
							gridTemplateColumns: '1fr 1fr',
							gap: '1rem',
							alignSelf: 'stretch',
						}}
					>
						{/* Work Periods */}
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'flex-start',
								gap: '1rem',
							}}
						>
							<TimesheetServices
								isModal={true}
								services={loadedData.services}
							/>
						</Box>

						{/* Work Regime & Availability */}
						<Box
							sx={{
								display: 'grid',
								gap: '1rem',
							}}
						>
							<WorkRegimeAndAgent
								workTypes={workTypes}
								isTimeSheetApproved={isTimeSheetApproved}
								workType={workType}
								handleWork={handleWork}
								isModal={true}
							/>

							<Box>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell
												colSpan={loadedData.workTimes.length}
												align='center'
												sx={{
													fontFamily: 'Poppins, sans-serif',
													fontSize: '0.75rem',
													fontWeight: 600,
													lineHeight: '200%',
													letterSpacing: '0.17px',
													color: '#8695AF',
													backgroundColor: 'rgba(245, 247, 252, 0.50)',
												}}
											>
												Horário Trabalhado
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											{loadedData.workTimes.map((workTime, index) => (
												<TableCell key={workTime.timeSheetApprovalWorkTimesId}>
													<Box sx={{ display: 'flex', flexDirection: 'column' }}>
														<Typography
															variant='body2'
															sx={{
																fontFamily: 'Poppins, sans-serif',
																fontWeight: 400,
																color: '#092056',
																fontSize: '0.75rem',
																lineHeight: '130%',
															}}
														>
															{workTime.startTime} - {workTime.endTime}
														</Typography>
														<Typography
															variant='body2'
															sx={{
																fontFamily: 'Poppins, sans-serif',
																fontWeight: 400,
																color: '#8695AF',
																fontSize: '0.75rem',
																lineHeight: '130%',
															}}
														>
															({elapsedworktimes[index].format('HH:mm')})
														</Typography>
													</Box>
												</TableCell>
											))}
										</TableRow>
									</TableBody>
								</Table>

								<Table>
									<TableHead>
										<TableRow>
											<TableCell
												align='center'
												colSpan={3}
												sx={{
													backgroundColor: 'rgba(245, 247, 252, 0.50)',
												}}
											>
												Totais por Período
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											<TableCell>
												<Box>
													<Typography
														variant='body2'
														sx={{
															fontFamily: 'Poppins, sans-serif',
															fontWeight: 400,
															color: '#092056',
															fontSize: '0.75rem',
															lineHeight: '130%',
														}}
													>
														Noturno Manhã
													</Typography>
													<Typography
														variant='body2'
														sx={{
															fontFamily: 'Poppins, sans-serif',
															fontWeight: 400,
															color: '#8695AF',
															fontSize: '0.75rem',
															lineHeight: '130%',
														}}
													>
														das 03:00 às 07:00
													</Typography>
												</Box>
												<Typography
													variant='body2'
													sx={{
														fontFamily: 'Poppins, sans-serif',
														fontWeight: 400,
														color: '#092056',
														fontSize: '0.75rem',
														lineHeight: '130%',
														marginTop: '1rem',
													}}
												>
													{dayjs().startOf('day').add(nightMorningHours, 'minute').format('HH:mm')}
												</Typography>
											</TableCell>
											<TableCell>
												<Box>
													<Typography
														variant='body2'
														sx={{
															fontFamily: 'Poppins, sans-serif',
															fontWeight: 400,
															color: '#092056',
															fontSize: '0.75rem',
															lineHeight: '130%',
														}}
													>
														Diurno
													</Typography>
													<Typography
														variant='body2'
														sx={{
															fontFamily: 'Poppins, sans-serif',
															fontWeight: 400,
															color: '#8695AF',
															fontSize: '0.75rem',
															lineHeight: '130%',
														}}
													>
														das 07:00 às 20:00
													</Typography>
												</Box>
												<Typography
													variant='body2'
													sx={{
														fontFamily: 'Poppins, sans-serif',
														fontWeight: 400,
														color: '#092056',
														fontSize: '0.75rem',
														lineHeight: '130%',
														marginTop: '1rem',
													}}
												>
													{dayjs().startOf('day').add(diurnalHours, 'minute').format('HH:mm')}
												</Typography>
											</TableCell>
											<TableCell>
												<Box>
													<Typography
														variant='body2'
														sx={{
															fontFamily: 'Poppins, sans-serif',
															fontWeight: 400,
															color: '#092056',
															fontSize: '0.75rem',
															lineHeight: '130%',
														}}
													>
														Noturno Tarde
													</Typography>
													<Typography
														variant='body2'
														sx={{
															fontFamily: 'Poppins, sans-serif',
															fontWeight: 400,
															color: '#8695AF',
															fontSize: '0.75rem',
															lineHeight: '130%',
														}}
													>
														das 20:00 às 03:00
													</Typography>
												</Box>
												<Typography
													variant='body2'
													sx={{
														fontFamily: 'Poppins, sans-serif',
														fontWeight: 400,
														color: '#092056',
														fontSize: '0.75rem',
														lineHeight: '130%',
														marginTop: '1rem',
													}}
												>
													{dayjs().startOf('day').add(nightAfternoonHours, 'minute').format('HH:mm')}
												</Typography>
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Box>

							<Box
								sx={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: '1rem',
									}}
								>
									<Typography
										variant='h6'
										sx={{
											fontFamily: 'Poppins, sans-serif',
											fontWeight: 600,
											fontSize: '0.875rem',
											color: 'var(--primary-dark)',
										}}
									>
										Disponibilidade Total
									</Typography>

									<TextField
										sx={{
											width: '115px',
											'& .MuiFormLabel-root': {
												color: '#092056 !important',
												fontFamily: 'Poppins, sans-serif',
												fontWeight: '500 !important',
											},
											'& .Mui-disabled': {
												backgroundColor: 'var(--secondary-light)',
												borderColor: 'rgba(134, 149, 175, 0.00)',
												'& input': {
													color: '#092056 !important',
													WebkitTextFillColor: '#092056 !important', // Ensures color for disabled input
												},
											},
											'& input[type="time" i]::-webkit-calendar-picker-indicator': {
												backgroundImage: 'none',
											},
										}}
										type='time'
										label='Total Horas'
										size='small'
										value={dayjs().startOf('day').add(8, 'hour').format('HH:mm')}
										disabled
										InputProps={{
											sx: {
												color: '#092056 !important',
												WebkitTextFillColor: '#092056 !important',
											},
										}}
									/>
								</Box>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: '1rem',
									}}
								>
									<Typography
										variant='h6'
										sx={{
											fontFamily: 'Poppins, sans-serif',
											fontWeight: 600,
											fontSize: '0.875rem',
											color: 'var(--primary-dark)',
										}}
									>
										Trabalho Extra
									</Typography>

									<TextField
										sx={{
											width: '115px',
											'& .MuiFormLabel-root': {
												color: '#092056 !important',
												fontFamily: 'Poppins, sans-serif',
												fontWeight: '500 !important',
											},
											'& .Mui-disabled': {
												backgroundColor: 'var(--secondary-light)',
												borderColor: 'rgba(134, 149, 175, 0.00)',
												'& input': {
													color: '#092056 !important',
													WebkitTextFillColor: '#092056 !important', // Ensures color for disabled input
												},
											},
											'& input[type="time" i]::-webkit-calendar-picker-indicator': {
												backgroundImage: 'none',
											},
										}}
										type='time'
										label='Total Horas'
										size='small'
										value={dayjs().startOf('day').add(extraHours, 'minute').format('HH:mm')}
										disabled
										InputProps={{
											sx: {
												color: '#092056 !important',
												WebkitTextFillColor: '#092056 !important',
											},
										}}
									/>
								</Box>
							</Box>

							<Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
								<Typography
									variant='h6'
									sx={{
										fontFamily: 'Poppins, sans-serif',
										fontWeight: 600,
										fontSize: '0.875rem',
										color: 'var(--primary-dark)',
										lineHeight: '157%',
									}}
								>
									Pausa
								</Typography>

								<RadioGroup
									row
									aria-labelledby='requisition-radio-group-label'
									name='requisition-radio-group'
									value={loadedData.dispDrivingBreak}
									// onChange={} // TODO: implement onChange handler
									sx={{
										marginLeft: '8px',
										gap: '1.5rem',
										'& .MuiTypography-body1': {
											fontFamily: 'Poppins, sans-serif',
											fontSize: '13px',
											fontWeight: 500,
											lineHeight: '130%',
											letterSpacing: '-1px',
											color: '#092056',
										},
										'& .MuiFormControlLabel-root': {
											display: 'flex',
											alignItems: 'center',
											gap: '0.125rem',
											marginRight: 0,
										},
										'& .MuiRadio-root': {
											padding: '2px',
										},
										'& .MuiSvgIcon-root': {
											fontSize: 18,
										},
									}}
								>
									<FormControlLabel
										value='0'
										label='2 pausas de 15/30 min'
										control={
											<Radio
												size='small'
												sx={{ fontSize: 18 }}
											/>
										}
										sx={{}}
									/>
									<FormControlLabel
										value='1'
										label='Pausa de 45 min'
										control={
											<Radio
												size='small'
												sx={{ fontSize: 18 }}
											/>
										}
										sx={{}}
									/>
									<FormControlLabel
										value='2'
										label='Sem Pausa'
										control={
											<Radio
												size='small'
												sx={{ fontSize: 18 }}
											/>
										}
										sx={{}}
									/>
								</RadioGroup>
							</Box>
						</Box>
					</Box>

					{/* Bonus */}
					<BonusCodes />

					{/* Contract type */}

					{/* Services */}

					{/* Observations */}
				</DialogContent>
				<DialogActions>
					<CustomButton
						size='small'
						variant='text'
						onClick={closeModal} // Call closeModal when Fechar is clicked
						sx={{ marginLeft: 'auto' }}
					>
						Fechar
					</CustomButton>
					<CustomButton
						size='small'
						onClick={() => {
							saveChages(data)
							closeModal()
						}} // Call closeModal when Fechar is clicked
						sx={{ marginLeft: 'auto' }}
					>
						Guardar
					</CustomButton>
				</DialogActions>
			</Paper>
		</Dialog>
	)
}

export default CustomModalVirtualTimesheet
